// import React, { useState, useEffect, useCallback } from "react";
// import { useSelector } from "react-redux";
// import { useCookies } from "react-cookie";
// import { v4 as uuidv4 } from "uuid";
// import toast from "react-hot-toast";
// import moment from "moment";
// import { MenuItem, Select, Tooltip } from "@mui/material";

// // Component imports
// import CustomButton from "../../../atoms/CustomButton";
// import CustomDataGrid from "../../../organisms/CustomDatagrid";
// import CustomMenu from "../../../atoms/CustomMenu";
// import NoContentCard from "../../../atoms/NoContentCard";
// import Search from "../../../molecules/search";
// import Pagination from "../../../molecules/Pagination";
// import DeleteModal from "../../../organisms/modals/DeleteModal";
// import Modal from "../../../organisms/modals/Modal";

// // Icon imports
// import VerticalMenu from "../../../icons/VerticalMenu";
// import Edit from "../../../icons/Edit";
// import Delete from "../../../icons/Delete";

// // Service imports
// import { getData, deleteData, patchData } from "../../../../services";
// import { formatTime } from "../../../../helpers/timeformathoursminsec";
// import {
//   TaskStatusDsr,
//   TaskStatusDsrOptions,
//   Priorities,
//   TaskType,
// } from "../../../../helpers/staticData";
// import TaskCustomDatagrid from "../../../organisms/CustomDatagrid/EditableTable";

// // DSR Form component
// import DSRForm from "../dailyStatusReport/Form";
// import DateRangePickerShortCuts from "../../../organisms/dateRangePicker";
// import { addHours,startOfDay,subDays } from "rsuite/esm/internals/utils/date";
// import TeamDSRForm from "./Form";
// import CommonFilter from "../../../atoms/CommonFilter";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import StatusBackground from "../../../atoms/StatusBackground";
// import { confimationStyles } from "../../../../assets/styles/toast";
// import { errorStyles } from "../../../molecules/Dropdown/dropdown";

// const TeamStatusReport = () => {
//   const [cookies] = useCookies([]);
//   const navigate = useNavigate();
//   const [searchParams, setSearchParams] = useSearchParams();
//   const [dsrData, setDsrData] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchedValue, setSearchedValue] = useState('');
//   const [isFormDirty, setIsFormDirty] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(25);
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [todayDsrExists, setTodayDsrExists] = useState(false);
//   const [filters, setFilters] = useState(() => {
//       const urlFilters = {};
//       if (searchParams.has("status")) {
//         urlFilters.status = JSON.parse(searchParams.get("status"));
//       }
//       return urlFilters;
//     });
//   const [modalState, setModalState] = useState({
//     isModalOpen: false,
//     modalData: null,
//     isDeleteModalOpen: false,
//     modalId: "",
//     name: "",
//     title: ""
//   });
//   const defaultToday = new Date();

//    const [date, setDate] = useState({
//       start_date: addHours(startOfDay(subDays(defaultToday, 14)), 12), // 14 days ago
//       end_date: addHours(startOfDay(defaultToday), 12), // Today
//     });
    
//       const accessData = useSelector((state) => state.accessDetails?.accessData);
//       const isAdmin = accessData?.role?.label === "Admin";

//   // Modified: Removed isAdmin check - everyone can create, edit, delete
//   const canCreate = true;
//   const canEdit = true;
//   const canDelete = true;


//   const filterOptions = [
//       {
//         id: "status",
//         label: "Status",
//         type: "multi-select",
//         options: TaskStatusDsr,
//       },
//     ];

//   // Fetch DSR data
//   const getDSRData = useCallback(async () => {
//     try {
//       setIsLoading(true);
      
//       const res = await getData({
//         endpoint: "StatusReport/GetAllDSRsOfEmployeeTeamsAsync",
//         params:{
//           start_date: date?.start_date,
//           end_date : date?.end_date,
//           search_query: searchedValue,
//           status: JSON.stringify(filters?.status),
//           employee_id : cookies.euid,
//           is_admin : isAdmin,
//         },
//         token: cookies.e_t,
//       });
      
//       if (res) {
//         // console.log("DSR response:", res);
//         setDsrData(res?.data);
        
//         // Check if today's DSR already exists
//         const today = moment().format("YYYY-MM-DD");
//         const todayEntry = res?.data?.find(entry => 
//           moment(entry.dsr_date).format("YYYY-MM-DD") === today
//         );
        
//         setTodayDsrExists(!!todayEntry);
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setIsLoading(false);
//     }
//   }, [cookies.e_t, currentPage, itemsPerPage, searchedValue,date,filters]);

//   useEffect(() => {
//     getDSRData();
//   }, [getDSRData]);

//   // Menu handling - modified to show all options for everyone
//   const menu = [
//     {
//       icon: <Edit height="20" width="20" />,
//       label: "View",
//       onClick: () => {
//         setAnchorEl(null);
//         handleEdit(selectedRow);
//       },
//     },
//     // {
//     //   icon: <Delete />,
//     //   label: "Delete",
//     //   onClick: () => {
//     //     setAnchorEl(null);
//     //     handleDeleteModal(selectedRow);
//     //   },
//     // },
//   ];

//   const handleDeleteModal = (data) => {
//     setModalState((prevState) => ({
//       ...prevState,
//       isDeleteModalOpen: true,
//       modalId: data.id,
//       name: data.name,
//     }));
//   };

//   const handleDeletion = async () => {
//     try {
//       const res = await deleteData({
//         endpoint: `StatusReport/DeleteDSRAsync?id=${modalState.modalId}`,
//         token: cookies.e_t,
//       });
      
//       if (res) {
//         getDSRData();
//         toast.success("DSR Entry Deleted Successfully", {
//           style: { 
//             background: '#34A853', 
//             color: '#fff' 
//           },
//           duration: 1000,
//         });
//       }
//     } catch (error) {
//       toast.error("An Error Occurred", {
//         style: { 
//           background: '#D32F2F', 
//           color: '#fff' 
//         },
//         duration: 1000,
//       });
//       console.error(error);
//     } finally {
//       setModalState((prevState) => ({
//         ...prevState,
//         isDeleteModalOpen: false,
//       }));
//     }
//   };

//   const handleStatusMenu = (event, row) => {
//     setAnchorEl(event.currentTarget);
//     setSelectedRow(row);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const handlePageChange = useCallback((page) => {
//     setCurrentPage(page);
//   }, []);

//   const handleItemsPerPageChange = useCallback((perPage) => {
//     setCurrentPage(1);
//     setItemsPerPage(perPage);
//   }, []);

//   const handleEdit = (tableData) => {
//     setModalState((prevState) => ({
//       ...prevState,
//       modalId: tableData.id,
//       modalData: tableData,
//       isModalOpen: true,
//       title: "DSR Entry",
//     }));
//   };

//   const handleFilterChange = (newFilters) => {
//     if (currentPage !== 1) {
//       setCurrentPage(1);
//     }
//     setFilters(newFilters);
//   };

//     const updateTaskField = async (taskId, field, value, token) => {
//       try {
//         const response = await patchData({
//           endpoint: `StatusReport/AutoApprovalDSRByIds`,
//           params: { status:value, },
//           data: [taskId],
//           token: token,
//         });
//         getDSRData();
//         return response;
//       } catch (error) {
//         throw error;
//       }
//     };

//   const columns = [
//     {
//       field: "employee_name",
//       headerName: "Name",
//       flex: 1.5,
//       sortable: true,
//     },
//     {
//       field: "totalLoggedTime",
//       headerName: "Hours Logged",
//       flex: 1.5,
//       sortable: true,
//       renderCell: (params) => {
//         return <span>{formatTime(params?.value)}</span>;
//       },
//     },
//     {
//       field: "totalTasks",
//       headerName: "Tasks Count",
//       flex: 1,
//       sortable: true,
//     },
//     {
//       field: "dsr_date",
//       headerName: "Dsr Date",
//       flex: 1.5,
//       sortable: true,
//       renderCell: (params) => {
//         return (
//           <div>
//              {moment(params?.value).format("DD/MM/YYYY")}
//           </div>
//         );
//       },
//     },
//     {
//       field: "status",
//       headerName: "Status",
//       flex: 1,
//       sortable: true,
//       renderCell: (params) => {
//         return (
//           <div className="d-flex items-center gap-2">
//             <StatusBackground status={params.value} />
//           </div>
//         );
//       },
//       cellClassName: "cursor-pointer",
//       editable: true,
//       renderEditCell: (params) => (
//         <Select
//           value={params.value}
//           className="editable-select"
//           onChange={async (e) => {
//             const newStatus = e.target.value;
//             const originalStatus = params.value;
    
//             // Set the new value immediately in the UI
//             params.api.setEditCellValue({
//               id: params.id,
//               field: params.field,
//               value: newStatus,
//             });
    
//             try {
//               // Make API call to update status
//               const row = params.api.getRow(params.id);
//               await updateTaskField(row.id, "status", newStatus, cookies.e_t);
              
//               // Show success toast
//               toast.success("Status updated successfully", {
//                 style: confimationStyles,
//                 duration: 1000,
//               });
//             } catch (error) {
//               // Revert to original status if API call fails
//               params.api.setEditCellValue({
//                 id: params.id,
//                 field: params.field,
//                 value: originalStatus,
//               });
              
//               // Show error toast
//               toast.error("Failed to update status", {
//                 style: errorStyles,
//                 duration: 1000,
//               });
//               console.error("Error updating status:", error);
//             }
//           }}
//           fullWidth
//         >
//           {TaskStatusDsrOptions.map((option) => (
//             <MenuItem
//               key={option}
//               value={option}
//               className="editable-select-option"
//             >
//               {option}
//             </MenuItem>
//           ))}
//         </Select>
//       ),
//       // Only allow editing for non-Completed statuses
//       cellEditStart: (params) => {
//         // console.log("This is edit params",params?.row?.status)
//         return params?.row?.status !== "Approved";
//       }
//     },
//     {
//       field: "actions",
//       headerName: "",
//       flex: 0.2,
//       renderCell: (params) => {
//         return (
//           <div className="table-icons-container">
//             <div onClick={(event) => handleStatusMenu(event, params.row)}>
//               <VerticalMenu />
//             </div>

//             <CustomMenu
//               anchorEl={anchorEl}
//               open={Boolean(anchorEl)}
//               onClose={handleClose}
//               items={menu}
//             />
//           </div>
//         );
//       },
//     },
//   ];

//   const openModal = (title, data = null) => {
//     const modalId = data ? data.id : uuidv4();
//     setModalState((prevState) => ({
//       ...prevState,
//       modalId,
//       isModalOpen: true,
//       title,
//       modalData: data,
//     }));
//   };

//   const closeModal = (type) => {
//     if (type === 'submit') {
//       setIsFormDirty(false);
//     }
//     setModalState((prevState) => ({ 
//       ...prevState, 
//       isModalOpen: false,
//       modalData: null
//     }));
//   };

//   const CustomNoRowsOverlay = React.memo(() => {
//     return (
//       <>
//         <NoContentCard
//           title="No Team DSR Found"
//           type="Task"
//           // subtitle={
//           //   "Looks like you’re all caught up—check back later for new assignments."
//           // }
//         />
//       </>
//     );
//   });

//   return (
//     <div id="Daily-Status-Report" className="main-container">
//     <div className="d-flex justify-content-between">
//        <div className="d-flex gap-2">
//         <div className="d-flex gap-2 ">
//           <Search
//             placeholder="Search"
//             onSearchEmit={(item) => {
//               if (currentPage !== 1) {
//                 setCurrentPage(1);
//               }
//               setSearchedValue(item);
//             }}
//           />
//         </div>
//         <div className="">
//           <CommonFilter
//             filters={filterOptions}
//             onFilterChange={handleFilterChange}
//             initialFilters={filters}
//           />
//         </div>
//         </div>
//         <div>
//         <DateRangePickerShortCuts setDate={setDate} />
//         </div>
//       </div>

//       <div className="mt-3">
//         <TaskCustomDatagrid
//           columns={columns}
//           CustomNoRowsOverlay={CustomNoRowsOverlay}
//           rows={dsrData || []}
//           isLoadingStateProvided={true}
//           isLoading={isLoading}
//           onCellClick={(params) => {
//             if (params.field !== "actions" && params.field !== "status") {
//               handleEdit(params.row);
//             }
//           }}
//           canEdit={true}
//         />
//       </div>

//       {dsrData?.total_records > 10 && (
//         <Pagination
//           itemsPerPage={itemsPerPage}
//           totalItems={dsrData?.total_records}
//           currentPage={currentPage}
//           onPageChange={handlePageChange}
//           onItemsPerPageChange={handleItemsPerPageChange}
//         />
//       )}

//       {modalState.isModalOpen && (
//         <Modal
//           id={modalState.modalId}
//           title={modalState.title}
//           isActive={modalState.isModalOpen}
//           onClose={closeModal}
//           takeConfirmation={isFormDirty ? true : false}
//           width="800px"
//           maxHeight="800px"
//         >
//           <TeamDSRForm
//             teamdsr={true}
//             onFormDirty={setIsFormDirty}
//             initialData={
//               modalState.title === "DSR Entry" ? modalState.modalData : null
//             }
//             refetchData={getDSRData}
//             onClose={() => closeModal("submit")}
//           />
//         </Modal>
//       )}

//       {modalState.isDeleteModalOpen && (
//         <DeleteModal
//           name={modalState.name}
//           id={modalState.modalId}
//           isActive={modalState.isDeleteModalOpen}
//           onClose={() =>
//             setModalState((prevState) => ({
//               ...prevState,
//               isDeleteModalOpen: false,
//             }))
//           }
//           title="DSR Entry"
//           onClick={handleDeletion}
//         />
//       )}
//     </div>
//   );
// };

// export default TeamStatusReport;


import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { v4 as uuidv4 } from "uuid";
import toast from "react-hot-toast";
import moment from "moment";
import { MenuItem, Select, Tooltip } from "@mui/material";

// Component imports
import CustomButton from "../../../atoms/CustomButton";
import CustomDataGrid from "../../../organisms/CustomDatagrid";
import CustomMenu from "../../../atoms/CustomMenu";
import NoContentCard from "../../../atoms/NoContentCard";
import Search from "../../../molecules/search";
import Pagination from "../../../molecules/Pagination";
import DeleteModal from "../../../organisms/modals/DeleteModal";
import Modal from "../../../organisms/modals/Modal";

// Icon imports
import VerticalMenu from "../../../icons/VerticalMenu";
import Edit from "../../../icons/Edit";
import Delete from "../../../icons/Delete";

// Service imports
import { getData, deleteData, patchData } from "../../../../services";
import { formatTime } from "../../../../helpers/timeformathoursminsec";
import {
  TaskStatusDsr,
  TaskStatusDsrOptions,
  Priorities,
  TaskType,
} from "../../../../helpers/staticData";
import TaskCustomDatagrid from "../../../organisms/CustomDatagrid/EditableTable";

// DSR Form component
import DSRForm from "../dailyStatusReport/Form";
import DateRangePickerShortCuts from "../../../organisms/dateRangePicker";
import { addHours,startOfDay,subDays } from "rsuite/esm/internals/utils/date";
import TeamDSRForm from "./Form";
import CommonFilter from "../../../atoms/CommonFilter";
import { useNavigate, useSearchParams } from "react-router-dom";
import StatusBackground from "../../../atoms/StatusBackground";
import { confimationStyles } from "../../../../assets/styles/toast";
import { errorStyles } from "../../../molecules/Dropdown/dropdown";

// Import the Rejection Remark Form
import RemarkForm from "./RemarkForm";

const TeamStatusReport = () => {
  const [cookies] = useCookies([]);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [dsrData, setDsrData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchedValue, setSearchedValue] = useState('');
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [selectedRow, setSelectedRow] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [todayDsrExists, setTodayDsrExists] = useState(false);
  
  // New state for rejection modal
  const [rejectionModal, setRejectionModal] = useState({
    isOpen: false,
    rowId: null,
    originalStatus: "",
    isLoading: false
  });
  
  const [filters, setFilters] = useState(() => {
      const urlFilters = {};
      if (searchParams.has("status")) {
        urlFilters.status = JSON.parse(searchParams.get("status"));
      }
      return urlFilters;
    });
  const [modalState, setModalState] = useState({
    isModalOpen: false,
    modalData: null,
    isDeleteModalOpen: false,
    modalId: "",
    name: "",
    title: ""
  });
  const defaultToday = new Date();

   const [date, setDate] = useState({
      start_date: addHours(startOfDay(subDays(defaultToday, 14)), 12), // 14 days ago
      end_date: addHours(startOfDay(defaultToday), 12), // Today
    });
    
      const accessData = useSelector((state) => state.accessDetails?.accessData);
      const isAdmin = accessData?.role?.label === "Admin";

  // Modified: Removed isAdmin check - everyone can create, edit, delete
  const canCreate = true;
  const canEdit = true;
  const canDelete = true;


  const filterOptions = [
      {
        id: "status",
        label: "Status",
        type: "multi-select",
        options: TaskStatusDsr,
      },
    ];

  // Fetch DSR data
  const getDSRData = useCallback(async () => {
    try {
      setIsLoading(true);
      
      const res = await getData({
        endpoint: "StatusReport/GetAllDSRsOfEmployeeTeamsAsync",
        params:{
          start_date: date?.start_date,
          end_date : date?.end_date,
          search_query: searchedValue,
          status: JSON.stringify(filters?.status),
          employee_id : cookies.euid,
          is_admin : isAdmin,
        },
        token: cookies.e_t,
      });
      
      if (res) {
        setDsrData(res?.data);
        
        // Check if today's DSR already exists
        const today = moment().format("YYYY-MM-DD");
        const todayEntry = res?.data?.find(entry => 
          moment(entry.dsr_date).format("YYYY-MM-DD") === today
        );
        
        setTodayDsrExists(!!todayEntry);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [cookies.e_t, currentPage, itemsPerPage, searchedValue,date,filters]);

  useEffect(() => {
    getDSRData();
  }, [getDSRData]);

  // Menu handling - modified to show all options for everyone
  const menu = [
    {
      icon: <Edit height="20" width="20" />,
      label: "View",
      onClick: () => {
        setAnchorEl(null);
        handleEdit(selectedRow);
      },
    },
    // {
    //   icon: <Delete />,
    //   label: "Delete",
    //   onClick: () => {
    //     setAnchorEl(null);
    //     handleDeleteModal(selectedRow);
    //   },
    // },
  ];

  const handleDeleteModal = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isDeleteModalOpen: true,
      modalId: data.id,
      name: data.name,
    }));
  };

  const handleDeletion = async () => {
    try {
      const res = await deleteData({
        endpoint: `StatusReport/DeleteDSRAsync?id=${modalState.modalId}`,
        token: cookies.e_t,
      });
      
      if (res) {
        getDSRData();
        toast.success("DSR Entry Deleted Successfully", {
          style: { 
            background: '#34A853', 
            color: '#fff' 
          },
          duration: 1000,
        });
      }
    } catch (error) {
      toast.error("An Error Occurred", {
        style: { 
          background: '#D32F2F', 
          color: '#fff' 
        },
        duration: 1000,
      });
      console.error(error);
    } finally {
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));
    }
  };

  const handleStatusMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const handleEdit = (tableData) => {
    setModalState((prevState) => ({
      ...prevState,
      modalId: tableData.id,
      modalData: tableData,
      isModalOpen: true,
      title: "DSR Entry",
    }));
  };

  const handleFilterChange = (newFilters) => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
    setFilters(newFilters);
  };

  // Updated to handle rejection remarks
  const updateTaskField = async (taskId, field, value, token, remarks = null) => {
    try {
      const requestParams = { status: value };
      if (remarks) {
        requestParams.remarks = remarks;
      }
      
      const response = await patchData({
        endpoint: `StatusReport/AutoApprovalDSRByIds`,
        params: requestParams,
        data: [taskId],
        token: token,
      });
      getDSRData();
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  // Handle rejection remarks submission
  const handleRejectionSubmit = async (remark) => {
    const { rowId, originalStatus } = rejectionModal;
    setRejectionModal(prev => ({ ...prev, isLoading: true }));
    
    try {
      await updateTaskField(rowId, "status", "Rejected", cookies.e_t, remark);
      
      // Show success toast
      toast.success("Status updated with remarks", {
        style: confimationStyles,
        duration: 1000,
      });
      
      // Close modal
      setRejectionModal({
        isOpen: false,
        rowId: null,
        originalStatus: "",
        isLoading: false
      });
    } catch (error) {
      // Show error toast
      toast.error("Failed to update status", {
        style: errorStyles,
        duration: 1000,
      });
      console.error("Error updating status:", error);
    } finally {
      setRejectionModal(prev => ({ ...prev, isLoading: false }));
    }
  };

  const columns = [
    {
      field: "employee_name",
      headerName: "Name",
      flex: 1.5,
      sortable: true,
    },
    {
      field: "totalLoggedTime",
      headerName: "Hours Logged",
      flex: 1.5,
      sortable: true,
      renderCell: (params) => {
        return <span>{formatTime(params?.value)}</span>;
      },
    },
    {
      field: "totalTasks",
      headerName: "Tasks Count",
      flex: 1,
      sortable: true,
    },
    {
      field: "dsr_date",
      headerName: "Dsr Date",
      flex: 1.5,
      sortable: true,
      renderCell: (params) => {
        return (
          <div>
             {moment(params?.value).format("DD/MM/YYYY")}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        return (
          <div className="d-flex items-center gap-2">
            <StatusBackground status={params.value} />
          </div>
        );
      },
      cellClassName: "cursor-pointer",
      editable: true,
      renderEditCell: (params) => (
        <Select
          value={params.value}
          className="editable-select"
          onChange={async (e) => {
            const newStatus = e.target.value;
            const originalStatus = params.value;
            
            // If status is changed to "Rejected", open remarks modal
            if (newStatus === "Rejected") {
              setRejectionModal({
                isOpen: true,
                rowId: params.id,
                originalStatus: originalStatus,
                isLoading: false
              });
              return;
            }
    
            // Set the new value immediately in the UI for non-rejection statuses
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newStatus,
            });
    
            try {
              // Make API call to update status
              const row = params.api.getRow(params.id);
              await updateTaskField(row.id, "status", newStatus, cookies.e_t);
              
              // Show success toast
              toast.success("Status updated successfully", {
                style: confimationStyles,
                duration: 1000,
              });
            } catch (error) {
              // Revert to original status if API call fails
              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: originalStatus,
              });
              
              // Show error toast
              toast.error("Failed to update status", {
                style: errorStyles,
                duration: 1000,
              });
              console.error("Error updating status:", error);
            }
          }}
          fullWidth
        >
          {TaskStatusDsrOptions.map((option) => (
            <MenuItem
              key={option}
              value={option}
              className="editable-select-option"
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      ),
      // Only allow editing for non-Completed statuses
      cellEditStart: (params) => {
        return params?.row?.status !== "Approved";
      }
    },
    {
      field: "actions",
      headerName: "",
      flex: 0.2,
      renderCell: (params) => {
        return (
          <div className="table-icons-container">
            <div onClick={(event) => handleStatusMenu(event, params.row)}>
              <VerticalMenu />
            </div>

            <CustomMenu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              items={menu}
            />
          </div>
        );
      },
    },
  ];

  const openModal = (title, data = null) => {
    const modalId = data ? data.id : uuidv4();
    setModalState((prevState) => ({
      ...prevState,
      modalId,
      isModalOpen: true,
      title,
      modalData: data,
    }));
  };

  const closeModal = (type) => {
    if (type === 'submit') {
      setIsFormDirty(false);
    }
    setModalState((prevState) => ({ 
      ...prevState, 
      isModalOpen: false,
      modalData: null
    }));
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        <NoContentCard
          title="No Team DSR Found"
          type="Task"
          // subtitle={
          //   "Looks like you're all caught up—check back later for new assignments."
          // }
        />
      </>
    );
  });

  return (
    <div id="Daily-Status-Report" className="main-container">
      <div className="d-flex justify-content-between">
         <div className="d-flex gap-2">
          <div className="d-flex gap-2 ">
            <Search
              placeholder="Search"
              onSearchEmit={(item) => {
                if (currentPage !== 1) {
                  setCurrentPage(1);
                }
                setSearchedValue(item);
              }}
            />
          </div>
          <div className="">
            <CommonFilter
              filters={filterOptions}
              onFilterChange={handleFilterChange}
              initialFilters={filters}
            />
          </div>
          </div>
          <div>
          <DateRangePickerShortCuts setDate={setDate} />
          </div>
        </div>

      <div className="mt-3">
        <TaskCustomDatagrid
          columns={columns}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          rows={dsrData || []}
          isLoadingStateProvided={true}
          isLoading={isLoading}
          onCellClick={(params) => {
            if (params.field !== "actions" && params.field !== "status") {
              handleEdit(params.row);
            }
          }}
          canEdit={true}
        />
      </div>

      {dsrData?.total_records > 10 && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={dsrData?.total_records}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {modalState.isModalOpen && (
        <Modal
          id={modalState.modalId}
          title={modalState.title}
          isActive={modalState.isModalOpen}
          onClose={closeModal}
          takeConfirmation={isFormDirty ? true : false}
          width="800px"
          maxHeight="800px"
        >
          <TeamDSRForm
            teamdsr={true}
            onFormDirty={setIsFormDirty}
            initialData={
              modalState.title === "DSR Entry" ? modalState.modalData : null
            }
            refetchData={getDSRData}
            onClose={() => closeModal("submit")}
          />
        </Modal>
      )}

      {modalState.isDeleteModalOpen && (
        <DeleteModal
          name={modalState.name}
          id={modalState.modalId}
          isActive={modalState.isDeleteModalOpen}
          onClose={() =>
            setModalState((prevState) => ({
              ...prevState,
              isDeleteModalOpen: false,
            }))
          }
          title="DSR Entry"
          onClick={handleDeletion}
        />
      )}
      
      {/* Rejection Remarks Modal with RemarkForm */}
      {rejectionModal.isOpen && (
        <Modal
          id="rejection-remarks-modal"
          title="Rejection Remarks"
          isActive={rejectionModal.isOpen}
          onClose={() => {
            // Reset cell to original value when canceling
            if (rejectionModal.rowId) {
              const gridApi = document.querySelector('.MuiDataGrid-root')?.api;
              if (gridApi) {
                gridApi.setEditCellValue({
                  id: rejectionModal.rowId,
                  field: 'status',
                  value: rejectionModal.originalStatus,
                });
              }
            }
            
            setRejectionModal({
              isOpen: false,
              rowId: null,
              originalStatus: "",
              isLoading: false
            });
          }}
          width="500px"
          maxHeight="400px"
        >
          <RemarkForm 
            onClose={() => {
              // Reset cell to original value when canceling
              if (rejectionModal.rowId) {
                const gridApi = document.querySelector('.MuiDataGrid-root')?.api;
                if (gridApi) {
                  gridApi.setEditCellValue({
                    id: rejectionModal.rowId,
                    field: 'status',
                    value: rejectionModal.originalStatus,
                  });
                }
              }
              
              setRejectionModal({
                isOpen: false,
                rowId: null,
                originalStatus: "",
                isLoading: false
              });
            }}
            onSubmit={handleRejectionSubmit}
          />
        </Modal>
      )}
    </div>
  );
};

export default TeamStatusReport;